import { render, staticRenderFns } from "./WaterFall.vue?vue&type=template&id=d350b5fa&"
import script from "./WaterFall.vue?vue&type=script&lang=js&"
export * from "./WaterFall.vue?vue&type=script&lang=js&"
import style0 from "./WaterFall.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports